<template>
    <div class="consultant">
        <div class="warp">
            <el-button type="primary" @click="getBrokers">查看申请</el-button>
            <el-dialog
                title="置业顾问申请"
                :visible.sync="showpicker"
                width="1200px">
                <div class="consultant-warp">
                    <div class="head">
                        <el-form ref="form" label-width="80px" :inline="true" size="mini">
                            <el-form-item label="状态筛选">
                                <el-select v-model="status" value-key="" placeholder="请选择" clearable filterable >
                                    <el-option label="待审核" value="01"></el-option>
                                    <el-option label="二次提交" value="02"></el-option>
                                    <el-option label="已通过" value="03"></el-option>
                                    <el-option label="不通过" value="04"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="search">搜索</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="table-box">
                        <el-table :data="brokers" border stripe :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}" size="mini">
                            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
                            <el-table-column prop="team" label="团队类型" width="80"></el-table-column>
                            <el-table-column label="头像" width="70" align="center">
                                <template slot-scope="s">
                                    <el-avatar class="custom-avatar" v-if="s.row.ltpic" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic" fit="fill"></el-avatar>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="姓名" width="80" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="telephone" label="手机" ></el-table-column>
                            <el-table-column prop="company" label="公司" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="projectname" label="申请楼盘" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="addDate" label="申请时间" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="putaway" label="状态" align="center">
                                <template slot-scope="s">
                                    <span v-if="s.row.status=='01'" class="text text-danger">待审核</span>
                                    <span v-if="s.row.status=='02'" class="text text-danger">二次申请</span>
                                    <span v-if="s.row.status=='03'" class="text text-success">已通过</span>
                                    <span v-if="s.row.status=='04'" class="text text-warning">不通过</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="admin" label="操作" width="102">
                                <template slot-scope="s">
                                    <el-button type="primary" size="mini" plain @click="todetail(s.row)">查看详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination class="page-tion"
                            @current-change="currentChange"
                            layout="prev, pager, next"
                            :page-size="pagesize"
                            :total="total" background>
                        </el-pagination>
                    </div>
                </div>
            </el-dialog>
            
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConsultantApply',
    data() {
        return {
            showpicker: false,
            status: '',
            pageNo: 1,
            pagesize: 8,
            brokers: [],
            total: 0,
        }
    },
    methods: {
        todetail(item) {
            if (!item.uid){
                this.$alert('没有关联用户，无效的数据');
                return;
            }
            this.$router.push({path: '/project/user/detail', query: {uid: item.uid}})
        },
        search() {
            this.pageNo = 1;
            this.getBrokers();
        },
        getBrokers() {
            this.showpicker = true;
            var params = {
                status: this.status,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            };
            this.$api.getConsultantBorkerList(params).then(
                data=>{
                    let {list, total} = data;
                    for(let item of list){
                        if (item.ltpic.indexOf('[')>-1){
                            item.ltpic = JSON.parse(item.ltpic)[0];
                        }
                    }
                    this.brokers = list;
                    this.total = total;
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.getBrokers();
        },
    },
}
</script>

<style lang="scss" scoped>
.consultant{
    float: right;
    margin-left: 10px;
    .custom-avatar{
        float: left;
    }
}
</style>